import { Controller } from "@hotwired/stimulus"

const relativeTime = new Intl.RelativeTimeFormat("en", { numeric: "always" })

export default class extends Controller {
  static targets = ["label"]
  static values = { startsAt: String, endsAt: String }

  connect() {
    this.startsAt = Date.parse(this.startsAtValue)
    this.endsAt = Date.parse(this.endsAtValue)
    this.update()
    this.timer = setInterval(() => this.update(), 30_000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  update() {
    const now = Date.now()
    const upcoming = now < this.startsAt
    const ended = now >= this.endsAt
    const prefix = upcoming ? "Starts" : ended ? "Ended" : "Started"
    const difference = (ended ? this.endsAt : this.startsAt) - now
    const seconds = Math.abs(difference) / 1000
    let distance

    if (seconds < 60) {
      distance = upcoming ? "in less than a minute" : "less than a minute ago"
    } else {
      const [unit, duration] = seconds >= 86400 ? ["day", 86400] : seconds >= 3600 ? ["hour", 3600] : ["minute", 60]
      distance = relativeTime.format(Math.round(difference / 1000 / duration), unit)
    }

    this.labelTarget.textContent = `${prefix} ${distance}`
    this.labelTarget.hidden = false
  }
}
